// extracted by mini-css-extract-plugin
export default {"header":"header--Af50n","img":"img--N3lK1","minWidth":"minWidth--Sq7dI"};